import cx from 'classnames'
import React from 'react'

import Image from '@cinch/oxd-components/image/src'
import { isIE } from '@cinch/oxd-utils/browser-support/src'

import styles from './product-image.module.css'

interface Props {
  isAvailable?: boolean
  image: string
  unavailableImageMessage: string
  unavailableVehicleMessage?: string
  alt: React.ImgHTMLAttributes<any>['alt']
  isPending: boolean
}

interface UnavailableProps extends Props {
  isAvailable: false
  unavailableVehicleMessage: string
}

const ProductImage: React.FC<Props | UnavailableProps> = ({
  isAvailable,
  image,
  unavailableImageMessage,
  alt,
  isPending,
  children,
}) => {
  const imageProps = {
    className: cx(styles.img, { [styles.unavailable]: !isAvailable }),
    i18n: { noImage: isPending || (!isPending && !!image) ? '' : unavailableImageMessage },
  }

  return (
    <div
      className={cx(styles.imgContainer, { [styles.ieObjectFit]: isIE() })}
      style={isIE() && !!image ? { backgroundImage: `url(${image})` } : {}}
    >
      {!isIE() ? (
        <Image {...imageProps} src={image} alt={alt} isLazy={true} />
      ) : !image ? (
        <Image {...imageProps} />
      ) : null}
      {children}
    </div>
  )
}

export default ProductImage
